/*
 * @Description:
 * @version:
 * @Author: guyifeng
 * @Date: 2020-10-09 16:56:43
 * @LastEditors: guyifeng
 * @LastEditTime: 2020-10-14 11:04:14
 */
import Oss from '@teana/oss';
import { fetchOSSToken } from '@/api/oss';


export const getOSSToken = () => fetchOSSToken().then((res) => ({
  Expiration: res.expiration,
  AccessKeyId: res.accessKeyId,
  AccessKeySecret: res.accessKeySecret,
  SecurityToken: res.securityToken,
}));

export const ossInstance = new Oss({
  bucket: 'zhishi',
  getOSSToken,
});

export const ossOrigin = 'https://m.xiguacity.cn';

export function convertBlobToFile(blob, fileName, options = {}) {
  return new File([blob], fileName, options);
}

export async function upload(blob, fileName) {
  if (!blob) return Promise.reject(new Error('不存在Blob文件流'));
  const directory = '/xigua-im';
  const file = convertBlobToFile(blob, fileName);
  await ossInstance.put(`${directory}/${fileName}`, file);
  return `${ossOrigin}${directory}/${fileName}`;
}
